import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import { getSearchableAsset } from 'owa-timestream-asset-search';
import { selectedResultFilter } from '../selectors/searchViewSelectors';

/**
 * Compares two search results
 * @param {SearchResultItem} item1 first result to compare
 * @param {SearchResultItem} item2 second result to compare
 * @returns positive number if item1 > item2, otherwise returns negative number
 */
export default function compareResults(item1: SearchResultItem, item2: SearchResultItem): number {
    const searchableAsset = getSearchableAsset(item1.type);
    return searchableAsset.compareAssets(item1, item2, selectedResultFilter());
}
